import utils from "../../../../../utils";
import React, { useEffect, useState } from "react";
import Context from "../../../../../context";
import dictionary from "../../../../../dictionary";

import {
  CustomIcon,
  CustomLeaflet,
  CustomModal,
  CustomView,
  UserInformation,
} from "../../../../../components";
import values from "../../../../../values";
import api from "../../../../../api";
import { useQuery } from "react-query";
import {
  ICityItem,
  IProvinceItem,
} from "../../../../../types/common.interface";
import { useTranslation } from "react-i18next";

const StudentInformation = () => {
  const { showModal, setShowModal, selectedUser } = React.useContext(
    Context.ServiceScreen
  );

  const student = selectedUser?.student;
  const { t } = useTranslation();

  return (
    <section id="service-screen-show-user-information show-information">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        minWidth={"50vw"}
        maxWidth={"60vw"}
        open={showModal === "SHOW_STUDENT_INFORMATION"}
        overlayClose
      >
        <CustomView.Container className="scroll-content">
          <div className="show-user-information-header">
            <CustomView.Row>
              <CustomView.Column medium={10}>
                <UserInformation
                  avatar={student?.avatar}
                  name={student?.firstName ? student?.firstName : student?.name}
                  lastName={student?.lastName ? student?.lastName : ""}
                  phoneNumber={
                    student?.phoneNumber
                      ? student?.phoneNumber
                      : student?.telephone
                  }
                  isBlock={null}
                />
              </CustomView.Column>
              <CustomView.Column medium={2}>
                <div style={{ marginTop: "0.5rem" }}>
                  <CustomIcon
                    icon="fas fa-user-pen"
                    hoverTitle={t("updateStudent")}
                    onClick={() => setShowModal!("UPDATE_STUDENT")}
                  />
                </div>
              </CustomView.Column>
            </CustomView.Row>
          </div>
          <hr />
          <CustomView.Row className="form-column-row">
            {student?.city && (
              <CustomView.Column
                medium={5}
                small={12}
                large={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("city")} :</label>
                <p>{selectedUser?.city?.Name}</p>
              </CustomView.Column>
            )}
            {student?.gender && (
              <CustomView.Column
                medium={5}
                small={12}
                large={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("gender")} :</label>
                <p>{dictionary.genderEnglish2Persian(student?.gender)}</p>
              </CustomView.Column>
            )}
            {(student?.disability === false ||
              student?.disability === true) && (
              <CustomView.Column
                medium={5}
                small={12}
                large={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("physicalCondition")} :</label>
                <p>
                  {student?.disability === true
                    ? t("specialConditions")
                    : t("healthy")}
                </p>
              </CustomView.Column>
            )}
            {student?.nationality && (
              <CustomView.Column
                medium={5}
                small={12}
                large={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("nationality")} :</label>
                <p>{student?.nationality}</p>
              </CustomView.Column>
            )}
            {student?.province && (
              <CustomView.Column
                medium={5}
                small={12}
                large={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("province")} :</label>
                <p>{selectedUser?.province?.Name}</p>
              </CustomView.Column>
            )}
            {student?.birthDate && (
              <CustomView.Column
                medium={5}
                small={12}
                large={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("birthday")} :</label>
                {utils.convertGregorianToJalali({
                  date: student.birthday,
                  format: "jYYYY/jMM/jDD",
                })}
              </CustomView.Column>
            )}
            {student?.state && (
              <CustomView.Column
                medium={5}
                small={12}
                large={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("area")} :</label>
                <p>{student?.state}</p>
              </CustomView.Column>
            )}
            {student?.grade && (
              <CustomView.Column
                medium={5}
                small={12}
                large={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("grade")} :</label>
                <p>
                  {
                    values.dropdownItems.GRADE.find(
                      (item) => item._id === student?.grade
                    )?.name
                  }
                </p>
              </CustomView.Column>
            )}
            {student?.field && (
              <CustomView.Column
                medium={5}
                small={12}
                large={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("field")} :</label>
                <p>
                  {
                    values.dropdownItems.FIELD.find(
                      (item) => item._id === student?.field
                    )?.name
                  }
                </p>
              </CustomView.Column>
            )}
            {student?.address && (
              <CustomView.Column
                medium={5}
                small={12}
                large={3}
                className="form-values form-column"
              >
                <label className="form-label">{t("address")} :</label>
                <p>{student?.address}</p>
              </CustomView.Column>
            )}
          </CustomView.Row>

          <hr />

          {student?.timing && (
            <CustomView.Container>
              <DayWrap weekday={utils.convertServiceTiming.mongoToHtml(student?.timing?.saturday )} label={t("saturday" )} />
              <DayWrap weekday={utils.convertServiceTiming.mongoToHtml(student?.timing?.sunday   )} label={t("sunday"   )} />
              <DayWrap weekday={utils.convertServiceTiming.mongoToHtml(student?.timing?.monday   )} label={t("monday"   )} />
              <DayWrap weekday={utils.convertServiceTiming.mongoToHtml(student?.timing?.tuesday  )} label={t("tuesday"  )} />
              <DayWrap weekday={utils.convertServiceTiming.mongoToHtml(student?.timing?.wednesday)} label={t("wednesday")} />
              <DayWrap weekday={utils.convertServiceTiming.mongoToHtml(student?.timing?.thursday )} label={t("thursday" )} />
              <DayWrap weekday={utils.convertServiceTiming.mongoToHtml(student?.timing?.friday   )} label={t("friday"   )} />
            </CustomView.Container>
          )}

          {student?.lat && (student?.lng || student?.long) && (
            <CustomView.Row className="center-row-content">
              <CustomLeaflet
                defaultLat={student.lat}
                defaultLng={student.lng}
              />
            </CustomView.Row>
          )}
        </CustomView.Container>
      </CustomModal>
    </section>
  );

  function DayWrap({ weekday, label }: any) {
    if (weekday?.close === true) return null;
    console.log(weekday?.departTime)
    if (weekday) {
      return (
        <div>
          <CustomView.Row className="timing form-row">
            <CustomView.Column medium={1}>
              <label className="form-label">{label}</label>
            </CustomView.Column>
            <CustomView.Column medium={2} className="form-colum timing-col">
              <div className="form-week-day">
                {" "}
                <div>{t("boardingTime")} </div>
                <strong>
                  {weekday?.pickupTime &&
                    utils.convertGregorianToJalali({
                      date: weekday?.pickupTime,
                      format: "hh:mm",
                    })}
                </strong>
              </div>
            </CustomView.Column>
            <CustomView.Column className="form-colum timing-col" medium={2}>
              <div className="form-week-day">
                <div>{t("enterTime")}</div>
                <div>
                  <strong>
                    {weekday?.entranceTime &&
                      utils.convertGregorianToJalali({
                        date: weekday?.entranceTime,
                        format: "hh:mm",
                      })}
                  </strong>
                </div>
              </div>
            </CustomView.Column>
            <CustomView.Column className="form-colum timing-col" medium={2}>
              <div className="form-week-day">
                <div>{t("leaveTime")}</div>
                <div>
                  <strong>
                    {weekday?.departTime &&
                      utils.convertGregorianToJalali({
                        date: weekday?.departTime,
                        format: "hh:mm ",
                      })}
                  </strong>
                </div>
              </div>
            </CustomView.Column>
          </CustomView.Row>
        </div>
      );
    }
    return <></>;
  }
};

export default StudentInformation;
